import { configureStore } from "@reduxjs/toolkit";
import allCandidateDetailsReducer from "../features/candidateDetails";

export const store = configureStore({
  reducer: {
    newCandidates: allCandidateDetailsReducer,
  },
});
